import { render, staticRenderFns } from "./SchoolProduct.vue?vue&type=template&id=e8d9b49a&scoped=true&"
import script from "./SchoolProduct.vue?vue&type=script&lang=js&"
export * from "./SchoolProduct.vue?vue&type=script&lang=js&"
import style0 from "./SchoolProduct.vue?vue&type=style&index=0&id=e8d9b49a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d9b49a",
  null
  
)

export default component.exports